var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","color":"blue white--text text-capitalize subtitle-1 text-align-left"},on:{"click":_vm.signUpWithFb}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("mdi-facebook")]),_vm._v(" Login using facebook ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }